export const IMAGE_POPUP_MODE = {
    CONTROLLED: 'CONTROLLED',
    UNCONTROLLED: 'UNCONTROLLED',
} as const;
